import React from 'react';

import { DropdownMenuItem, GMetrixButtonDropdown } from 'components/GMetrixButtonDropdown/GMetrixButtonDropdown';
import { Col, Container, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';

import 'components/TileContainer/tile-container.scss';

import { useIntl } from 'react-intl';

import 'components/TileContainer/tile-container.scss';

interface SearchOptions {
    className?: string;
    searchTerm: string;
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

interface ButtonDropDownList {
    itemActionList: (() => void)[];
    itemTextList: string[];
}

interface TileContainerProps {
    addButton?: boolean;
    addButtonCustom?: React.ReactNode;
    addButtonDisabled?: boolean;
    addButtonDisabledTooltip?: string;
    addButtonOnClick?: () => void;
    buttonDropDownItemList?: ButtonDropDownList;
    buttonVerification?: () => void;
    children: React.ReactNode | React.ReactNode[];
    className?: string;
    customTitle?: React.ReactNode;
    onError?: (message: string) => void;
    searchOptions?: SearchOptions;
    showBorder?: boolean;
    showButtonAsDropDown?: boolean;
    showButtonAsDropDownText?: string;
    showHr?: boolean;
    title?: string | React.ReactNode;
}

export function TileContainer({
    addButton = false,
    addButtonCustom,
    addButtonDisabled = false,
    addButtonDisabledTooltip,
    addButtonOnClick,
    buttonDropDownItemList,
    children,
    className,
    customTitle,
    searchOptions,
    showBorder = false,
    showButtonAsDropDown = false,
    showButtonAsDropDownText,
    showHr = true,
    title
}: TileContainerProps) {

    const { formatMessage } = useIntl();

    const reorderData = (dataList: ButtonDropDownList | undefined) => {

        const orderedObjectArray = [];
        if (dataList === undefined) {

            return [] as DropdownMenuItem[];

        }
        for (let index = 0; index < dataList.itemTextList.length; index++) {

            const text = dataList.itemTextList[index];
            const action = dataList.itemActionList[index];
            orderedObjectArray.push({ action, text });

        }
        return orderedObjectArray as DropdownMenuItem[];

    };

    const hasHeaderContent = Boolean(customTitle || title || searchOptions || addButton);

    return (
        <div className={`tile-container ${className ? className : ''}`}>
            {hasHeaderContent && (
                <Row className="pb-3">
                    {customTitle && (
                        customTitle
                    )}
                    {!customTitle && title && (
                        <Col
                            className="d-flex align-items-center"
                            md={!addButton ? 12 : 7}
                            xs={12}
                        >
                            <h3 className="text-strong">
                                {title}
                            </h3>
                        </Col>
                    )}
                    {!title && !customTitle && searchOptions && (
                        <Col
                            className={`${searchOptions.className}`}
                            md={3}
                            xs={12}
                        >
                            <GMetrixInput
                                onChange={(e: any) => searchOptions.setSearchTerm(e.target.value)}
                                placeholder={formatMessage({ id: 'search.0ab06b2c', defaultMessage: 'Search' })}
                                value={searchOptions.searchTerm}
                            />
                        </Col>
                    )}

                    {addButton && (
                        <Col
                            className="d-flex align-items-center justify-content-end"
                            md={!title && !customTitle && !searchOptions ? 12 : !title && !customTitle && searchOptions ? 9 : 5}
                            xs={12}
                        >
                            <div>
                                {addButtonCustom === undefined ? (
                                    <>
                                        {addButtonDisabled && addButtonDisabledTooltip ? (
                                            <OverlayTrigger
                                                overlay={(
                                                    <Popover id="tile-container-disabled-tooltip">
                                                        <Popover.Body>
                                                            {addButtonDisabledTooltip}
                                                        </Popover.Body>
                                                    </Popover>
                                                )}
                                                placement="left"
                                                trigger={['hover', 'focus']}
                                            >
                                                <span className="d-inline-block">
                                                    {showButtonAsDropDown ? (
                                                        <GMetrixButtonDropdown
                                                            buttonText={showButtonAsDropDownText}
                                                            dataItems={reorderData(buttonDropDownItemList)}
                                                            disabled={addButtonDisabled}
                                                            iconClass="fa-solid fa-plus"
                                                            variant="primary"
                                                        />
                                                    ) : (
                                                        <GMetrixButton
                                                            disabled={addButtonDisabled}
                                                            iconClass="fa-solid fa-plus"
                                                            onClick={() => addButtonOnClick && addButtonOnClick()}
                                                            size="sm"
                                                            variant="primary"
                                                        ></GMetrixButton>
                                                    )}
                                                </span>
                                            </OverlayTrigger>
                                        ) : (
                                            <>
                                                {showButtonAsDropDown ? (
                                                    <GMetrixButtonDropdown
                                                        buttonText={showButtonAsDropDownText}
                                                        dataItems={reorderData(buttonDropDownItemList)}
                                                        disabled={addButtonDisabled}
                                                        iconClass="fa-solid fa-plus"
                                                        variant="primary"
                                                    />
                                                ) : (
                                                    <GMetrixButton
                                                        disabled={addButtonDisabled}
                                                        iconClass="fa-solid fa-plus"
                                                        onClick={() => addButtonOnClick && addButtonOnClick()}
                                                        size="sm"
                                                        variant="primary"
                                                    ></GMetrixButton>
                                                )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    addButtonCustom
                                )}
                            </div>
                        </Col>
                    )}
                    {title && !customTitle && searchOptions && (
                        <Col className={`${searchOptions.className}`}>
                            <GMetrixInput
                                onChange={(e: any) => searchOptions.setSearchTerm(e.target.value)}
                                placeholder={formatMessage({ id: 'search.0ab06b2c', defaultMessage: 'Search' })}
                                value={searchOptions.searchTerm}
                            />
                        </Col>
                    )}
                </Row>
            )}
            {showHr && <hr className="mt-0 mb-3" />}
            {children}
        </div>
    );

}
